var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c("pulse-loader", {
        staticClass: "text-center",
        attrs: { loading: _vm.loading, color: _vm.loadingColor },
      }),
      _vm._v(" "),
      !_vm.loading && _vm.orders
        ? _c("div", [
            _c("div", { staticClass: "card" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "card-body" }, [
                _c("table", { staticClass: "table table-sm" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    [
                      _vm._l(_vm.orders, function (order, index) {
                        return [
                          _c("OrderTableView", {
                            attrs: {
                              order: order,
                              index: index,
                              salaryRates: _vm.salaryRates,
                            },
                          }),
                          _vm._v(" "),
                          _c("tr", [
                            _c(
                              "td",
                              { attrs: { colspan: "10" } },
                              [
                                _vm.actions[order.id].orderCorrectionOpen
                                  ? _c("div", [
                                      _c(
                                        "div",
                                        { staticClass: "input-group mb-3" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.actions[order.id]
                                                    .correction,
                                                expression:
                                                  "actions[order.id].correction",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              type: "text",
                                              placeholder:
                                                "Данные для коррекции",
                                            },
                                            domProps: {
                                              value:
                                                _vm.actions[order.id]
                                                  .correction,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.actions[order.id],
                                                  "correction",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("LoadingButton", {
                                            attrs: {
                                              title: "Отправить",
                                              color: "#5BBFDE",
                                              className:
                                                "btn btn-outline-success",
                                              loading:
                                                _vm.actions[order.id].loading,
                                              onClick: () =>
                                                _vm.updateOrder(
                                                  "send_correction",
                                                  order.id
                                                ),
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.actions[order.id].salaryRateChange
                                  ? _c("div", [
                                      _vm._m(2, true),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "input-group mb-3" },
                                        [
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.actions[order.id]
                                                      .newSalaryRate,
                                                  expression:
                                                    "actions[order.id].newSalaryRate",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              on: {
                                                change: function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.$set(
                                                    _vm.actions[order.id],
                                                    "newSalaryRate",
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "option",
                                                { attrs: { value: "0" } },
                                                [_vm._v("Стандарт")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "option",
                                                { attrs: { value: "1" } },
                                                [_vm._v("Область")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "option",
                                                { attrs: { value: "2" } },
                                                [_vm._v("Дальняя")]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.actions[order.id].comment,
                                                expression:
                                                  "actions[order.id].comment",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              type: "text",
                                              placeholder:
                                                "Комментарий по необходимости",
                                            },
                                            domProps: {
                                              value:
                                                _vm.actions[order.id].comment,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.actions[order.id],
                                                  "comment",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("LoadingButton", {
                                            attrs: {
                                              title: "Отправить запрос",
                                              color: "#5BBFDE",
                                              className:
                                                "btn btn-outline-success",
                                              loading:
                                                _vm.actions[order.id].loading,
                                              onClick: () =>
                                                _vm.updateOrder(
                                                  "send_salary_correction",
                                                  order.id
                                                ),
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "dropdown-menu",
                                  {
                                    staticClass: "menu",
                                    attrs: {
                                      "menu-title": "",
                                      "dark-mode": "auto",
                                    },
                                  },
                                  [
                                    _c(
                                      "section",
                                      {
                                        staticClass: "option",
                                        on: {
                                          click: function ($event) {
                                            return _vm.openDialog(
                                              order.id,
                                              "orderCorrectionOpen"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("button", [
                                          _c("strong", [_vm._v("Коррекция")]),
                                        ]),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "desc" }, [
                                          _vm._v(
                                            "изменения кол. смена адреса, статуса и тд"
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "section",
                                      {
                                        staticClass: "option",
                                        on: {
                                          click: function ($event) {
                                            return _vm.openDialog(
                                              order.id,
                                              "salaryRateChange"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("button", [
                                          _c("strong", [
                                            _vm._v("Смена ставки ЗП"),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "desc" }, [
                                          _vm._v(
                                            "изменения стаки ЗП - высокая, область"
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("tr", { staticClass: "divider" }, [
                            _c("td", { attrs: { colspan: "10" } }),
                          ]),
                        ]
                      }),
                    ],
                    2
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text-right" }, [
                  _c("p", [
                    _vm._v("Всего: "),
                    _c("strong", [_vm._v(_vm._s(_vm.total.total))]),
                  ]),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading && _vm.shifted && _vm.shifted.length
        ? _c("div", [
            _c("div", { staticClass: "card" }, [
              _vm._m(3),
              _vm._v(" "),
              _c("div", { staticClass: "card-body" }, [
                _c("table", { staticClass: "table table-sm" }, [
                  _vm._m(4),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    [
                      _vm._l(_vm.shifted, function (order, index) {
                        return [
                          _vm.loadingOrders[order.id]
                            ? [
                                _c("tr", [
                                  _c(
                                    "td",
                                    { attrs: { colspan: "10" } },
                                    [
                                      _c("pulse-loader", {
                                        staticClass: "text-center",
                                        attrs: {
                                          loading: true,
                                          color: _vm.loadingColor,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                              ]
                            : [
                                _c("OrderTableView", {
                                  attrs: {
                                    order: order,
                                    index: index,
                                    salaryRates: _vm.salaryRates,
                                  },
                                }),
                              ],
                          _vm._v(" "),
                          _c("tr", [
                            _c(
                              "td",
                              { attrs: { colspan: "10" } },
                              [
                                _c(
                                  "dropdown-menu",
                                  {
                                    staticClass: "menu",
                                    attrs: {
                                      "menu-title": "",
                                      "dark-mode": "auto",
                                    },
                                  },
                                  [
                                    _c(
                                      "section",
                                      {
                                        staticClass: "option",
                                        on: {
                                          click: function ($event) {
                                            return _vm.updateOrder(
                                              "restore_order",
                                              order.id
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("button", [
                                          _c("strong", [
                                            _vm._v("Восстановить"),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "desc" }, [
                                          _vm._v(
                                            "заявка появляется в общем списке"
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]
                      }),
                    ],
                    2
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading && _vm.rejected && _vm.rejected.length
        ? _c("div", [
            _c("div", { staticClass: "card" }, [
              _vm._m(5),
              _vm._v(" "),
              _c("div", { staticClass: "card-body" }, [
                _c("table", { staticClass: "table table-sm" }, [
                  _vm._m(6),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    [
                      _vm._l(_vm.rejected, function (order, index) {
                        return [
                          _vm.loadingOrders[order.id]
                            ? [
                                _c("tr", [
                                  _c(
                                    "td",
                                    { attrs: { colspan: "10" } },
                                    [
                                      _c("pulse-loader", {
                                        staticClass: "text-center",
                                        attrs: {
                                          loading: true,
                                          color: _vm.loadingColor,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                              ]
                            : [
                                _c("OrderTableView", {
                                  attrs: {
                                    order: order,
                                    index: index,
                                    salaryRates: _vm.salaryRates,
                                  },
                                }),
                              ],
                          _vm._v(" "),
                          _c("tr", [
                            _c(
                              "td",
                              { attrs: { colspan: "10" } },
                              [
                                _c(
                                  "dropdown-menu",
                                  {
                                    staticClass: "menu",
                                    attrs: {
                                      "menu-title": "",
                                      "dark-mode": "auto",
                                    },
                                  },
                                  [
                                    _c(
                                      "section",
                                      {
                                        staticClass: "option",
                                        on: {
                                          click: function ($event) {
                                            return _vm.updateOrder(
                                              "restore_order",
                                              order.id
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("button", [
                                          _c("strong", [
                                            _vm._v("Восстановить"),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "desc" }, [
                                          _vm._v(
                                            "заявка появляется в общем списке"
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]
                      }),
                    ],
                    2
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header bg-success" }, [
      _c("h6", [
        _c("i", { staticClass: "icon-fa icon-fa-check" }),
        _vm._v(" Доставлены"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Адрес/Препараты")]),
        _vm._v(" "),
        _c("th", [_vm._v("Сумма")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [_vm._v("Отправить запрос на смену расчет ЗП")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header bg-info" }, [
      _c("h6", [
        _c("i", { staticClass: "icon-fa icon-fa-refresh" }),
        _vm._v(" Переносы"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Адрес/Препараты")]),
        _vm._v(" "),
        _c("th", [_vm._v("Сумма")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header bg-warning" }, [
      _c("h6", [
        _c("i", { staticClass: "icon-fa icon-fa-warning" }),
        _vm._v(" Отказы"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Адрес/Препараты")]),
        _vm._v(" "),
        _c("th", [_vm._v("Сумма")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }